<template>
  <div class="resource-content" v-loading="!data.title">
    <template v-if="data.title">
      <div class="container content">
        <h1>
          <resourceTag class="tag" :type="1" />
          {{ data.title }}
        </h1>
        <div class="info">大小：{{ data.remark }} 浏览量：{{ data.viewTimes }}</div>
        <div class="content-wrapper">
          <preview :path="data.location" :type="data.type" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import preview from "../components/preview.vue";
import resourceTag from "../components/resourceTag.vue";
import { resourceContent } from "@/api/api.js";
import util from "@/libs/util.js";

export default {
  name: "resourceContent",
  props: ["id"],
  data() {
    return {
      data: {}
    };
  },
  created() {
    // 获取资源详情
    resourceContent({
      contentId: this.id
    })
      .then(res => {
        // 返回数据
        res = res.contentModel;
        switch (res.contentType) {
          case 1:
            res.type = "video";
            res.location = util.buildResourcePath(res.location);
            break;
          case 2:
            res.type = "audio";
            res.location = util.buildResourcePath(res.location);
            break;
          case 4:
            res.type = "document";
            res.location = util.buildResourcePath(res.location);
            break;
          case 3:
            res.type = "image";
            res.location = util.buildResourcePath(res.location);
            break;
          case 7:
            res.type = "link";
            break;
          case 8:
            res.type = "richtext";
            break;
          default:
            res.type = "other";
            res.location = util.buildResourcePath(res.location);
        }

        this.data = res;
      })
      .catch(err => {
        // 异常情况
        console.log(err);
      });
  },
  methods: {
    download() {}
  },
  components: {
    preview,
    resourceTag
  }
};
</script>

<style scoped>
.content {
  margin-top: 40px;
  margin-bottom: 80px;
}

h1 {
  font-size: 24px;
  line-height: 32px;
}

.tag {
  margin-top: 7px;
  margin-right: 10px;
  vertical-align: top;
}

.info {
  margin-top: 10px;
  font-size: 12px;
  line-height: 16px;
  color: #969696;
}

.content-wrapper {
  margin-top: 16px;
}

@media (max-width: 767px) {
  .content {
    margin-top: 15px;
    margin-bottom: 30px;
  }
}
</style>
